function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncatched exception popping up in devtools
	return Promise.resolve().then(function() {
		throw new Error("Cannot find module '" + req + "'.");
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "../../../../../src/$$_gendir lazy recursive";


//////////////////
// WEBPACK FOOTER
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/$$_gendir lazy
// module id = ../../../../../src/$$_gendir lazy recursive
// module chunks = main